import React from 'react';

function EditColor({ ColorData, sendDataToParent }) {
  const handleChange = (e) => {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...ColorData,
      [name]: value,
    });
  };

  return (
    <div className="row">
      <div className="mb-3">
        <label className="form-label">
          Color Name <span style={{ color: 'red' }}>*</span>
        </label>
        <input type="hidden" name="ColorId" value={ColorData.ColorId ?? ''} />
        <input
          type="text"
          className="form-control"
          name="ColorName"
          value={ColorData.ColorName ?? ''}
          onChange={handleChange}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Color Code</label>
        <input
          type="text"
          className="form-control"
          name="ColorCode"
          value={ColorData.ColorCode ?? ''}
          onChange={handleChange}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Description</label>
        <textarea
          className="form-control h-100"
          rows="5"
          name="Description"
          value={ColorData.Description ?? ''}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default EditColor;
